"use client";

import { useIsMobile } from "@/hooks/useIsMobile";
import { useToggle } from "@/hooks/useToggle";
import { Link } from "@/i18n/navigation";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";

const FooterMenuColumn = ({ title, items }) => {
  const isMobile = useIsMobile();
  const [isOpen, toggleOpen] = useToggle(false);

  const handleToggle = () => {
    if (isMobile) {
      toggleOpen();
    }
  };
  return (
    <div
      className={clsx(
        "flex flex-col",
        isMobile && isOpen ? "gap-3" : "gap-0 md:gap-3",
      )}
    >
      <h3
        className="border-primary-weak flex cursor-pointer items-center justify-between border-b py-4 text-lg font-semibold md:cursor-auto md:border-0 md:p-0"
        onClick={handleToggle}
      >
        <span>{title}</span>
        <span className="md:hidden">
          <FontAwesomeIcon
            icon={byPrefixAndName.far["chevron-down"]}
            className={`transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
          />
        </span>
      </h3>
      <ul
        className={`flex min-w-3xs flex-col gap-3 overflow-hidden transition-all duration-300 ease-in-out ${
          isMobile
            ? `max-h-0 opacity-0 ${isOpen ? "max-h-96 opacity-100" : ""}`
            : "max-h-none opacity-100"
        }`}
      >
        {items.map((item, index) => (
          <li key={index}>
            <Link
              href={item.href}
              className="group text-foreground-muted hover:text-primary relative inline-flex flex-col gap-1"
            >
              <span>{item.text}</span>
              <span className="border-primary absolute bottom-0 left-0 hidden w-0 border-b transition-all group-hover:w-full md:block"></span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterMenuColumn;
